"use client";

import { useTranslation } from "react-i18next";

const statsKeys = [
  { value: "250K+", key: "activePlayers" },
  { value: "15+", key: "sportsActivities" },
  { value: "1.8M+", key: "courtBookings" },
  { value: "500K+", key: "playerConnections" },
];

export default function AboutStatsSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-primary-strong py-16 md:py-20">
      {/* Decorative shapes */}
      <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/5" />
      <div className="absolute -bottom-16 -right-16 h-80 w-80 rounded-full bg-primary/30" />

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="min-w-0 text-center">
          <h2 className="text-2xl font-black tracking-tight text-white sm:text-3xl md:text-4xl">
            {t("about.statsTitle")}
          </h2>
          <p className="mt-2 text-base text-white/85 sm:text-lg">
            {t("about.statsSubtitle")}
          </p>
        </div>

        <div className="mt-8 grid gap-6 sm:mt-12 sm:grid-cols-2 sm:gap-8 lg:grid-cols-4">
          {statsKeys.map((stat, idx) => (
            <div
              key={stat.key}
              className={`flex flex-col items-center py-6 text-center ${idx < 3 ? "lg:border-r lg:border-white/20" : ""}`}
            >
              <p className="text-3xl font-black text-white sm:text-4xl md:text-5xl">
                {stat.value}
              </p>
              <p className="mt-2 text-sm font-medium uppercase tracking-wider text-white/90">
                {t(`about.${stat.key}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
